import { render, staticRenderFns } from "./chosenImage.vue?vue&type=template&id=529bc332&scoped=true&"
import script from "./chosenImage.vue?vue&type=script&lang=js&"
export * from "./chosenImage.vue?vue&type=script&lang=js&"
import style0 from "./chosenImage.vue?vue&type=style&index=0&id=529bc332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529bc332",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VColorPicker,VContainer,VIcon,VSelect,VTextField})
